import ErrorPage from '../pages/ErrorPage/ErrorPage';
import routesGB from './routes';
import { reducersGB } from './reducers';

export const countryConfigGB = {
    errorPageComponent: ErrorPage,
    routes: routesGB,
    reducers: reducersGB
};
